import { render, staticRenderFns } from "./DGAAPI.vue?vue&type=template&id=116476e4&"
import script from "./DGAAPI.vue?vue&type=script&lang=js&"
export * from "./DGAAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports